import React from 'react';
import { Global, css } from '@emotion/core';

const GlobalStyles = () => (
  <Global
    styles={(theme) => css`
      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      img,
      svg {
        height: auto;
        max-width: 100%;
      }

      a {
        color: ${theme.color.colorBlue};

        &:hover {
          color: ${theme.color.colorBlueDark};
        }

        svg {
          margin-right: ${theme.scale.scaleDown03};
          vertical-align: middle;
        }
      }

      a:hover,
      a:active,
      a:focus,
      button:hover,
      button:active,
      [role='button']:hover,
      [role='button']:active {
        outline: none;
      }

      button:focus,
      [role='button']:focus,
      a:focus,
      .focus-class {
        outline: -webkit-focus-ring-color auto 1px;
      }

      [role='button']:hover {
        cursor: pointer;
      }

      b,
      strong {
        ${theme.font.whitneySemibold}
      }

      em,
      i {
        font-style: italic;
      }

      html,
      body {
        min-height: 100%;
      }

      html {
        background-color: ${theme.color.colorWhite};
      }

      body {
        ${theme.font.whitneyBook}
        color: ${theme.color.colorBlueDarkest};
        background-color: ${theme.color.colorWhite};
        font-size: ${theme.scale.scaleBase};
        line-height: 1.5;
        -moz-osx-font-smoothing: grayscale;
      }
    `}
  />
);

export default GlobalStyles;
